import { Directive, ElementRef, EventEmitter, Output, AfterViewInit, OnDestroy } from '@angular/core';

import { ResizeSensor } from 'css-element-queries';

@Directive({
  selector: '[resize]'
})
export class ResizeDirective implements AfterViewInit, OnDestroy {
  @Output('resize') onResize: EventEmitter<ClientRect> = new EventEmitter();

  constructor(
    private _elementRef: ElementRef
  ) { }

  private _sensor: ResizeSensor;

  public ngAfterViewInit() {
    this._sensor = new ResizeSensor(this._elementRef.nativeElement, () => this.onResize.emit(this._elementRef.nativeElement.getBoundingClientRect()));
  }

  public ngOnDestroy(): void {
    if (this._sensor) { this._sensor.detach(); }
  }
}
